import { Grid, Link, Stack } from "@mui/material";
import { Component } from "react";
import { Button } from "../../components/Button";
import { Paper } from "../../components/Paper";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";
import MaintenanceDrawing from "../../resources/images/drawing-maintenance.svg";
import OfflineDrawing from "../../resources/images/drawing-offline.svg";
import ErrorIcon from "../../resources/images/icons-warning.svg";

class ErrorPageBase extends Component<any & WithLocaleProps, any> {
  static defaultProps = {
    retryInterval: 30000 //30 secs
  };

  constructor(props: any) {
    super(props);

    this.state = {
      showMore: false,
      offline: !window.navigator.onLine,
      apiDown: window.navigator.onLine && props.error && props.error.isNetworkError
    };
  }

  componentDidMount() {
    if (this.state.apiDown) {
      //Todo: replace with ping/better check/status server - clear timer
      const timerId = setTimeout((t) => {
        window.location.reload();
      }, this.props.retryInterval);
    }
  }

  onShowMore() {
    this.setState({ showMore: !this.state.showMore });
  }

  onRetryClick(e: any) {
    window.location.reload();
  }

  renderMaintenanceView() {
    const { translate } = this.props;
    return (
      <Paper
        className='klayo-inactiveuserview'
        padding='44px 64px 48px 64px'
        sx={{ margin: { xs: "120px 16px 0 16px", md: "120px auto 0 auto" } }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <h1>{translate("errors.underMaintenance")}</h1>
            <div className='klayo-inactiveuserview_message'>
              {translate("errors.maintenanceMessage")}
            </div>
            <Stack direction='row' className='klayo-inactiveuserview_actions' spacing={2}>
              <Button
                label={translate("errors.retry")}
                variant='filled'
                onClick={this.onRetryClick.bind(this)}
              />
            </Stack>
          </Grid>
          <Grid item xs={6} className='klayo-inactiveuserview_drawing'>
            <MaintenanceDrawing />
          </Grid>
        </Grid>
      </Paper>
    );
  }

  renderOfflineView() {
    const { translate } = this.props;
    return (
      <Paper className='klayo-inactiveuserview' padding='44px 64px 48px 64px'>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <h1>{translate("errors.noInternet")}</h1>
            <div className='klayo-inactiveuserview_message'>
              {translate("errors.noInternetMessage")}
            </div>
            <Stack direction='row' className='klayo-inactiveuserview_actions' spacing={2}>
              <Button
                label={translate("errors.retry")}
                variant='filled'
                onClick={this.onRetryClick.bind(this)}
              />
            </Stack>
          </Grid>
          <Grid item xs={6} className='klayo-inactiveuserview_drawing'>
            <OfflineDrawing />
          </Grid>
        </Grid>
      </Paper>
    );
  }

  renderError() {
    const { error, translate } = this.props;
    const { showMore } = this.state;

    return (
      <Paper className='klayo-errorview' padding='30px 50px 50px 50px'>
        <Stack direction='row'>
          <ErrorIcon />
          <h1>{translate("errors.error")}</h1>
        </Stack>
        <div className='klayo-errorview_message'>
          {translate("errors.errorMessage").split("contact support")[0]}
          <Link href='https://www.klayo.com/contact-us/' target='_blank'>
            {translate("errors.contactSupport")}
          </Link>
          .
        </div>
        {error && (
          <div>
            <Link onClick={this.onShowMore.bind(this)} className='klayo-errorview_morelink'>
              {showMore ? translate("errors.hideDetails") : translate("errors.learnMore")}
            </Link>
            {showMore && (
              <div className='klayo-errorview_details'>
                <div>
                  <b>{translate("errors.detailedMessage")}</b> {error.message}
                </div>
                {error.httpStatus !== null && (
                  <div>
                    <b>{translate("errors.httpStatus")}</b> {error.httpStatus}
                  </div>
                )}
                {error.source !== null && (
                  <div>
                    <b>{translate("errors.source")}</b> {error.source}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </Paper>
    );
  }

  render() {
    const { error } = this.props;
    const { offline, apiDown } = this.state;

    if (apiDown) return this.renderMaintenanceView();
    else if (offline) return this.renderOfflineView();
    else return this.renderError();
  }
}

export const ErrorPage = withLocale(ErrorPageBase);
